import React from 'react';
import './Home.js.css';
import Container from '../components/Container';
import '../styles/generics.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageComponent from '../components/PageComponent';
import Labels from '../Labels';
import Connection from '../config/Connection';
import { Modal, Button, InputGroup, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Parsers from '../Tools/Parsers';
import GenericHelper from '../Tools/GenericHelper';
import AdminPage from './AdminPage';
import ErrorComponent from '../components/ErrorComponent';

export default class AdminUsersPage extends PageComponent {

  static PageInfo = {
    parent: AdminPage,
    path: "/Admin/Users",
    name: "menu.adminusers",
    permission: { "CONFIGURATION_USERS_LIST": true },
    access: { 1: true },
    icon: "users"
  }

  constructor(props) {
    super(props);
    this.state.loading = true;
    this.state.isModalVisible = false;
    this.state.modalInitializing = false;
    this.state.modalError = null;
    this.state.modalLoading = false;
    this.state.user = "";
  }

  componentDidMount() {

    Connection.Secure(Connection.service + 'User/List')
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            setTimeout(() => this.setState({ data: data, loading: false }));
          });
        else this.setState({ error: response, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error, loading: false });
      });
  }

  render() {
    return (
      <Container context={this.constructor}>

        <div className="generics_panels" style={{ display: "block" }}>
          {
            this.state.error != null ? <ErrorComponent error={this.state.error} /> :
              this.state.loading ? <div>{Labels.GetLabel("generic.loading")}</div> :
                <div>
                  <div className="generics_panels_header"><FontAwesomeIcon icon={this.constructor.PageInfo.icon} /> <span>{Labels.GetLabel(this.constructor.PageInfo.name)}</span></div>
                  {this.state.data
                    && this.state.data.length > 0 ? this.state.data.map((item) =>
                      <Link to={"/Admin/Users/Detail/" + item.keyRegister} className="generics_listing_item" >
                        <FontAwesomeIcon icon="user" className="generics_listing_item_icon" />
                        <div className="generics_listing_content" >
                          <div className="generics_listing_item_title" >{Parsers.parseUpperCase(GenericHelper.parseInformation(item.personValue, 1, "valueType"))}</div>
                          <div className="generics_listing_item_description" >{GenericHelper.parseInformation(item.personValue, 13, "valueType", null)} {GenericHelper.parseInformation(item.personValue, 18, "valueType", null, " - ")}</div>
                          <div className="generics_listing_item_description" >{Parsers.parseLowerCase(GenericHelper.parseInformation(item.personValue, 3, "valueType"))}<span>{Labels.GetLabel("generic.shortreg")}.:{GenericHelper.parseInformation(item.personValue, 16, "valueType", "0000000")}</span></div>
                        </div>
                      </Link>
                    )
                    : null}
                </div>
          }

          <Modal
            className={this.state.modalLoading == true ? "modal-loading" : ""}
            onHide={() => { }} show={this.state.isModalVisible}
          // onHide={handleClose}
          >
            <div>
              {
                this.state.modalInitializing == false ?
                  <div>
                    <Modal.Header>
                      <Modal.Title>{Labels.GetLabel("adminuserpage.newheader")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {Labels.GetLabel("adminuserpage.newlabel")}
                      <InputGroup className="mb-2">
                        <InputGroup.Prepend>
                          <InputGroup.Text> LONGPING\</InputGroup.Text>
                        </InputGroup.Prepend>
                        <Form.Control type="text" value={this.state.user} placeholder="" onChange={(text) => this.setState({ user: text.currentTarget.value, error: null })} />
                      </InputGroup>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={() => this.setState({ isModalVisible: false })}>
                        {Labels.GetLabel("adminuserpage.closebtn")}
                      </Button>
                      <Button variant="primary" disabled={this.state.user.length < 4} onClick={() => this.addUser()}>
                        {Labels.GetLabel("adminuserpage.savebtn")}
                      </Button>
                    </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                  </div>
                  : <div>
                    {Labels.GetLabel("adminuserpage.saving")}
                  </div>
              }
            </div>
          </Modal>
        </div>
      </Container >
    );
  }
}